import Cookies from "js-cookie"

export const changePreferredLang = (locale: string): void => {
  if (!["default", "nl", "de"].includes(locale)) throw new Error(`Only default, nl and de are valid values: ${locale}`)
  Cookies.set("wg_preferred_lang", locale)
}
